import { Button } from "antd";
import React from "react";
import { Link } from "react-router-dom";
import "./Home.css";
// import { render } from "enzyme";

export default function App() {
  
  const divStyle = {
    border:"1px solid #d1d5da"
  };

  return (
    <>
      {/* Display "Home" page content */}
      <div className="flex-container" >
        {/* giving inline style */}
        <div className="home-container container" style={divStyle}>
          <h1 className="home-welcome-text">
            Welcome to <img src="icon.svg" alt="QKart"></img>
          </h1>

          <p>Please select an option from below</p>

          <div className="home-buttons">
            <Link to="/register">
              <Button id="register-button" className="btn-block" type="primary" block={true}>
                Register
              </Button>
            </Link>

            {/* TODO: CRIO_TASK_MODULE_UNDERSTANDING_BASICS - Add a Login button */}
            <Link to="/login">
              <Button id="login-button" className="btn-block" type="primary" block={true}>
                Login
              </Button>
            </Link>

            <Link to="/products">
              <Button id="product-button" className="btn-block" type="primary" block={true}>
                Browse Products
              </Button>
            </Link>
            
          </div>
        </div>
      </div>
    </>
  );
}
